export default __webpack_public_path__ + "static/media/service_point_color.cac06bc9.svg";